"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["color", "size", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UsersIcon = function UsersIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.5 7a3.49 3.49 0 0 1 .663.067A3.97 3.97 0 0 0 7.8 8.375 2.475 2.475 0 0 0 6.5 8h-3A2.503 2.503 0 0 0 1 10.5V12h4.068a4.642 4.642 0 0 0-.218 1H0v-2.5A3.504 3.504 0 0 1 3.5 7zm1.456-3.564a3.969 3.969 0 0 0-.857 1.702A2.996 2.996 0 1 1 8 3a2.964 2.964 0 0 1-.044.436zM7 3a2 2 0 1 0-2 2 2.002 2.002 0 0 0 2-2zm5.5 7a3.504 3.504 0 0 1 3.5 3.5V16H6v-2.5A3.504 3.504 0 0 1 9.5 10zm-3 1A2.503 2.503 0 0 0 7 13.5V15h8v-1.5a2.503 2.503 0 0 0-2.5-2.5zM8 6a3 3 0 1 1 3 3 3.003 3.003 0 0 1-3-3zm1 0a2 2 0 1 0 2-2 2.002 2.002 0 0 0-2 2z"
    }));
  }

  if (size <= 24) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.5 9A3.5 3.5 0 1 0 4 5.5 3.504 3.504 0 0 0 7.5 9zm0-6A2.5 2.5 0 1 1 5 5.5 2.503 2.503 0 0 1 7.5 3zm2.713 14a5.456 5.456 0 0 0-.188 1H2v-3.5A4.505 4.505 0 0 1 6.5 10h2a4.503 4.503 0 0 1 4.414 3.649 5.518 5.518 0 0 0-.936.632A3.495 3.495 0 0 0 8.5 11h-2A3.504 3.504 0 0 0 3 14.5V17zm6.287-4A3.5 3.5 0 1 0 13 9.5a3.504 3.504 0 0 0 3.5 3.5zm0-6A2.5 2.5 0 1 1 14 9.5 2.503 2.503 0 0 1 16.5 7zM22 18.5a4.505 4.505 0 0 0-4.5-4.5h-2a4.505 4.505 0 0 0-4.5 4.5V22h11zM21 21h-9v-2.5a3.504 3.504 0 0 1 3.5-3.5h2a3.504 3.504 0 0 1 3.5 3.5z"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.5 11A4.5 4.5 0 1 0 6 6.5a4.505 4.505 0 0 0 4.5 4.5zm0-8A3.5 3.5 0 1 1 7 6.5 3.504 3.504 0 0 1 10.5 3zm1.166 19a6.98 6.98 0 0 0-.14 1H2v-5.5A5.506 5.506 0 0 1 7.5 12h6a5.464 5.464 0 0 1 2.65.683 5.985 5.985 0 0 0-.138 1.085A4.474 4.474 0 0 0 13.5 13h-6A4.505 4.505 0 0 0 3 17.5V22zm9.834-4a4.5 4.5 0 1 0-4.5-4.5 4.505 4.505 0 0 0 4.5 4.5zm0-8a3.5 3.5 0 1 1-3.5 3.5 3.504 3.504 0 0 1 3.5-3.5zm3 9h-6a5.506 5.506 0 0 0-5.5 5.5V30h17v-5.5a5.506 5.506 0 0 0-5.5-5.5zM29 29H14v-4.5a4.505 4.505 0 0 1 4.5-4.5h6a4.505 4.505 0 0 1 4.5 4.5z"
  }));
};

var _default = UsersIcon;
exports["default"] = _default;